// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2M1sJ","tab":"ProcedureTabs_tab__3w08t"};